




































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import UserInquiryForm from '../../../api/v2/forms/user_inquiry'
import Simplemde from '../atoms_molecules/Simplemde.vue'
import { userState } from '../../stores/user'
import { userInquiryState } from '../../stores/user_inquiries'
import Inquiry from '../../../api/v2/models/inquiry'
import markdownParser from '../../../../helpers/markdown-parser'

@Component({
  components: {
    Simplemde
  }
})
export default class UserInquiryDialog extends Vue {
  @Prop({
    default: null
  })
  inquiry: Inquiry | null

  dialog: boolean = false
  hasAsked: boolean = false
  name: string = ''
  body: string = ''
  invalidName: boolean = false
  invalidBody: boolean = false
  inquiryForm: UserInquiryForm
  isNotConfirm: boolean = true
  confirmed: boolean = false
  errorMessage: string = ''
  
  get user() {
    return userState.user
  }

  get markdownBody(): string {
    return markdownParser(this.body)
  }

  created() {
    this.setData()
  }

  @Watch('dialog')
  watchDialog(){
    if (this.dialog) {
      this.setData()
    }
  }

  setData(){
    this.name = this.inquiry?.title ?? ''
    this.body = this.inquiry?.body ?? ''
  }

  changeToConfirm() {
    this.confirmed = true
    this.isNotConfirm = false
  }

  backToForm(){
    this.isNotConfirm = true
    this.confirmed = false
  }

  get currentTime() {
    var today = new Date();
    return `${today.getFullYear()}-${(today.getMonth()+1)}-${today.getDate()}`;
  }

  async createInquiry() {
    this.invalidName = !this.name
    this.invalidBody = !this.body
    this.errorMessage = ''
    if (this.invalidName || this.invalidBody) return

    const inquiryForm = new UserInquiryForm()

    inquiryForm.name = this.name
    inquiryForm.body = this.body
    try {　
      if (this.inquiry) {
        await userInquiryState.update(this.inquiry.id,inquiryForm)
      } else {
        await userInquiryState.create(inquiryForm)
      }

      this.hasAsked = true
      this.isNotConfirm = true
      this.confirmed = true
      this.isNotConfirm = true
      this.setData()
      this.invalidName = false
      this.invalidBody = false
      this.$emit('inquirySubmited')

      setTimeout(() => {
        this.dialog = false
      }, 3000)
    } catch(e) {
      this.errorMessage = "お問い合わせ内容には日本語を含めてください。"
    }
  }
}
